import {useMemo} from "react";

export const useAspectRatio = (aspectRatio) =>
{
    return useMemo(() => {
        const v = aspectRatio.split(":");
        return parseInt(v[0]) / parseInt(v[1]);
    }, [aspectRatio]);
}